/** backend-client parses every wire timestamp into a Date, so these take one. */
export function formatDate(at: Date): string {
  return at.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function formatWhen(at: Date): string {
  return at.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function newestFirst(a: { createdAt: Date }, b: { createdAt: Date }): number {
  return b.createdAt.getTime() - a.createdAt.getTime();
}
